import axios from 'axios'
import React, { Fragment } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal, Container } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import {CarpetaDigitalComponent} from 'defcol-caso-general'

import Bitacora from '../../bitacora'
 import { useLocation, useNavigate } from 'react-router-dom'
import Desistir from './modalDesistir/desistir'

const Acciones = ({setAction}) => {

  const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))

  const history =useNavigate()
  const [show, setShow] = useState(false)
  const [showCarpeta, setShowCarpeta] = useState(false)
  const [showDesistir, setShowDesistir] = useState(false)
  const [showBitacora, setShowBitacora] = useState(false)
  const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
  const { cfg_form41, llaves} = data_recepciona
  const handleClose = () => {
   
      setShow(false)
  }
  const handleShow = () => setShow(true)
 
   const handleShowBitacora = () => setShowBitacora(true)
   const handleCloseBitacora= () => setShowBitacora(false)
   const handleShowCarpeta = () => setShowCarpeta(true)
   const handleCloseCarpeta= () => setShowCarpeta(false)
   
   const handleShowDesistir= () => setShowDesistir(true)
 
  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #D59B49;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color: #F0BA62;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
    .btn-desistir {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 168px;
      }
    .btn-desistir:hover{
            background-color: #87c9dc;
            color: #FFFFFF;
    } 

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      <Bitacora
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />
      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          prototipo={2}
          // docRef={{Id:200, uso:'LOcura', formato:'dfdf'}}
         />
      </Modal>
      <Container>
      <Row>
        <Col className='d-flex align-items-end justify-content-end m-2'>
          <Button className='m-2 w-auto' variant='outline-info'    onClick={()=> history('/area-trabajo-recupero-directo',{state:{queryState}} )} >
          {cfg_form41 && cfg_form41.cfg_form41["recepcasoasignadodef-btn-volver"]}
          </Button>
          <Button className='m-2 ' variant='carpeta' onClick={handleShowCarpeta}>
          {cfg_form41 && cfg_form41.cfg_form41["recepcasoasignadodef-btn-carpeta"]}
          </Button>
          <Button className='m-2' variant='desistir' onClick={handleShowDesistir}>
            {cfg_form41 && cfg_form41.cfg_form41["recepcasoasignadodef-btn-desisteasig"]}
          </Button>          
          <Button
            className='m-2'
            variant='recepcionar'
            type='onSubmit'
            //onSubmit={formik.handleSubmit}
            onClick={()=>setAction("Recepcionar")}
            name='recepcionar'
          >
            {cfg_form41 && cfg_form41.cfg_form41["recepcasoasignadodef-btn-recp"]}
          </Button>
        </Col>
      </Row>
      </Container>

      <Desistir 
        showDesistir={showDesistir}
        setShowDesistir={setShowDesistir}
      />
    </>
  )
}

export default Acciones
